import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { CommonObject } from "../utils/Utility";
import { EvPageThemeComponent } from "./ev-page-theme.component";
import { NgClass } from "@angular/common";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";

@Component({
    selector: 'ev-dialog-material',
    template: `
<div class="dialog-shell" [ngClass]="className">
  <h2 class="dialog-title" mat-dialog-title>{{title}}</h2>
  <mat-dialog-content class="dialog-content">
    <ng-content select="[main]"></ng-content>

    @if (text) {
      <p [innerHTML]="text"></p>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions" align="end">
    <ng-content select="[buttons]"></ng-content>

    @if (type === 'CLOSE') {
      <button class="dialog-action dialog-action--primary" mat-raised-button color="primary" (click)="close(true)">Chiudi</button>
    }
    @if (type === 'YES_NO') {
      <button class="dialog-action dialog-action--secondary" mat-raised-button (click)="close(false)">No</button>
      <button class="dialog-action dialog-action--primary" mat-raised-button color="primary" (click)="close(true)">Sì</button>
    }
  </mat-dialog-actions>
</div>
`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class EvDialogMaterialComponent extends EvPageThemeComponent {
    data = inject<CommonObject>(MAT_DIALOG_DATA);
    private dialogRef = inject<MatDialogRef<EvDialogMaterialComponent>>(MatDialogRef);

    // titolo della modale
    @Input() title: string
    // in base alla tipologia mostra dei pulsanti specifici
    @Input() type: 'CLOSE' | 'YES_NO'
    // testo della modale
    @Input() text: string = null
    // classe di stile (es per errore)
    @Input() className: string | string[] = null

    constructor() {
        super()
        const data = this.data;
        if (data) {
            this.type = data['type'] || 'CLOSE'
            this.text = data['text']
            this.title = data['title'] || 'Messaggio'
            this.className = data['panelClass'] || []
        }
    }

    close(value) {
        this.dialogRef.close(value)
    }
}
